module.exports = __webpack_public_path__ + "static/media/LI10.725728e1.jpg";